// ConditionsGenerales.jsx
// ———————————————————————————————————————————————————————————
// Page Conditions générales (CGU/CGV concentrées pour assurance)
// Remplacer les [CHAMPS] puis router vers /conditions-generales
// ———————————————————————————————————————————————————————————

import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import {
  Box,
  Paper,
  Typography,
  Divider,
  Link as MuiLink,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

function LegalLayout({ title, subtitle, children }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 5, px: 2 }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "1200px",
          borderRadius: "20px",
          px: { xs: 3, md: 6 },
          pt: { xs: 4, md: 6 },
          pb: { xs: 5, md: 6 },
          backgroundColor: "#F8F8F8",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <Typography
          gutterBottom
          sx={{
            color: "#000",
            fontWeight: 900,
            fontSize: { xs: "2.2rem", md: "3rem" },
            lineHeight: 1.2,
            mb: 1.5,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ color: "#444", fontWeight: 500, fontSize: "1.1rem", mb: 3 }}>
            {subtitle}
          </Typography>
        )}
        <Divider sx={{ mb: 4 }} />
        {children}
      </Paper>
    </Box>
  );
}

function SectionTitle({ children }) {
  return (
    <Typography sx={{ fontWeight: 800, fontSize: { xs: "1.35rem", md: "1.55rem" }, color: "#000", mt: 3, mb: 1 }}>
      {children}
    </Typography>
  );
}

function Paragraph({ children }) {
  return (
    <Typography sx={{ color: "#444", fontSize: "1.05rem", lineHeight: 1.7, mb: 2 }}>
      {children}
    </Typography>
  );
}

export default function ConditionsGenerales() {
  return (
    <>
      <Navbar />
      <Box sx={{ height: "50px" }} />
        <LegalLayout
        title={<><span>Conditions </span><Box component="span" sx={{ color: "#449F2D" }}>générales</Box></>}
        subtitle="Accès au site et souscription de vos assurances mobilité (vélos, trottinettes, etc.)."
        >
        <SectionTitle>Objet</SectionTitle>
        <Paragraph>
            Les présentes conditions encadrent l’accès au site [domaine] (ci-après « le Site »)
            et la souscription des contrats d’assurance « mobilité douce ». Elles complètent,
            pour chaque produit, la <strong>Notice d’information</strong> et la
            <strong> Fiche IPID</strong>. En cas de divergence, la Notice et/ou les conditions
            particulières prévalent.
        </Paragraph>

        <SectionTitle>Définitions</SectionTitle>
        <List dense sx={{ color: "#444" }}>
            <ListItem><ListItemText primary="Site : plateforme en ligne éditée par [Safe for Bike]." /></ListItem>
            <ListItem><ListItemText primary="Assureur : porteur du risque indiqué sur la Notice/IPID." /></ListItem>
            <ListItem><ListItemText primary="Intermédiaire : [Safe for Bike], distributeur du produit." /></ListItem>
            <ListItem><ListItemText primary="Produit : contrat d’assurance mobilité douce." /></ListItem>
        </List>

        <SectionTitle>Éligibilité – Biens assurés – Territoire</SectionTitle>
        <Paragraph>
            Produits destinés aux véhicules/équipements listés sur le Site (vélos, VAE, trottinettes,
            gyroroues, accessoires, etc.). Étendue territoriale, garanties, exclusions et limites : voir Notice/IPID.
        </Paragraph>

        <SectionTitle>Parcours de souscription</SectionTitle>
        <Paragraph>
            Vous renseignez les informations nécessaires (identité, contact, caractéristiques du bien, usages,
            moyens de paiement). La souscription est effective après validation et paiement. Les documents
            contractuels sont fournis sur support durable.
        </Paragraph>

        <SectionTitle>Prix & paiement</SectionTitle>
        <Paragraph>
            Prix TTC affichés en [devise]. Paiement via [prestataire de paiement]. En cas d’échec de paiement,
            la garantie peut être suspendue selon la réglementation et les conditions contractuelles.
        </Paragraph>

        <SectionTitle>Entrée en vigueur – Durée – Renouvellement</SectionTitle>
        <Paragraph>
            La date d’effet et la durée (mensuelle/annuelle, avec ou sans engagement) sont précisées pour
            chaque produit. Les modalités de renouvellement, suspension et résiliation appliquent le Code des assurances
            et sont détaillées dans la Notice et vos conditions particulières.
        </Paragraph>

        <SectionTitle>Droit de renonciation (contrat à distance – non vie)</SectionTitle>
        <Paragraph>
            Vous disposez d’un <strong>délai de 14 jours calendaires</strong> pour renoncer au contrat à compter
            de sa conclusion (modalités et exceptions prévues par le Code des assurances).
            En cas de renonciation, seule la part de prime correspondant à la période couverte reste due.
        </Paragraph>

        <SectionTitle>Réclamations – Médiation</SectionTitle>
        <Paragraph>
            Réclamation : [email réclamations] / [adresse postale]. À défaut de solution,
            vous pouvez saisir le médiateur (voir « Mentions légales »).
        </Paragraph>

        <SectionTitle>Responsabilités</SectionTitle>
        <Paragraph>
            Le Site est fourni « en l’état ». L’Intermédiaire n’est pas responsable de l’exécution des garanties,
            assurée par l’Assureur. En tout état de cause, responsabilité limitée au préjudice direct dans les limites légales.
        </Paragraph>

        <SectionTitle>Propriété intellectuelle</SectionTitle>
        <Paragraph>
            Les contenus du Site sont protégés. Toute extraction ou réutilisation substantielle est interdite.
        </Paragraph>

        <SectionTitle>Données personnelles – Cookies</SectionTitle>
        <Paragraph>
            Voir notre <MuiLink href="/politique-de-confidentialite">Politique de confidentialité</MuiLink>
            {" "}et notre <MuiLink href="/politique-de-cookies">Politique de cookies</MuiLink>.
        </Paragraph>

        <SectionTitle>Droit applicable – Tribunal compétent</SectionTitle>
        <Paragraph>
            Droit français. Les litiges sont soumis aux juridictions compétentes selon les règles applicables.
        </Paragraph>
        </LegalLayout>
        <Footer />
    </>
  );
}